import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PageTitleService {
  private _title$ = new BehaviorSubject<string>('Welcome back!');
  readonly title$ = this._title$.asObservable();

  set(title: string) {
    this._title$.next(title);
  }
}
